<template>
    <div class="px-4 py-3 flex items-center justify-between sm:px-6" v-if="paginator.prev || paginator.next">
        <div class="flex-1 flex justify-between">
            <span
                v-if="paginator.prev === null"
                class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-200 bg-white hover:bg-gray-50"
            >
                {{ $t('messages.previous') }}
            </span>
            <InertiaLink
                v-else
                :href="paginator.prev"
                class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
            >
                {{ $t('messages.previous') }}
            </InertiaLink>
            <span
                v-if="paginator.next === null"
                class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-200 bg-white hover:bg-gray-50"
            >
                {{ $t('messages.next') }}
            </span>
            <InertiaLink
                v-else
                :href="paginator.next"
                class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
            >
                {{ $t('messages.next') }}
            </InertiaLink>
        </div>
    </div>
</template>

<script>
import { Link as InertiaLink } from '@inertiajs/vue3';

export default {
    name: 'InertiaSimplePagination',
    props: {
        paginator: Object,
    },
    components: {
        InertiaLink,
    },
};
</script>
